<template>
 <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
      <section class="admin-right-sidebar">
						<div class="admin-right-sidebar-in">
							<div class="admin-right-sidebar-in-top">
								<div class="admin-custom-row">
									<div class="admin-right-sidebar-in-top-left">
										<h1>
                      {{ constants.MANAGE_EMAIL_LOGS_TEXT }}
										</h1>
									</div>

									<div class="admin-right-sidebar-in-top-right">
										<div class="admin-right-sidebar-in-top-right-top">
                      <div class="admin-search-box">
												<input id="seachEmailTempalteInput" type="text" placeholder="Search Email Logs" v-model="searchedText" @keyup.enter="fetchEmailLogs(), selectAll = false, selectedEmailLogs = [], fetchCounts()" />
											</div>
                    </div>
										<div class="admin-right-sidebar-in-top-right-btm">
                      <div class="tags">
												<ul>
													<li v-if="selectedEmailLogs.length > 0">
														<span>{{ selectedEmailLogs.length }} entries selected</span>
														<button id="tagCloseBtn" @click="selectedEmailLogs = [], selectAll = false"></button>
													</li>
												</ul>
											</div>
											<div class="delete-all-btn-link" v-if="selectedEmailLogs.length > 1">
												<button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('all')">
                          {{ constants.DELETE_ALL_BUTTON }}
												</button>
											</div>
                    </div>
									</div>
								</div>
							</div>

							<div class="admin-item-list-section email-logs-section">
								<div class="admin-item-list-section-in">
									<div class="admin-item-list-section-scroll">
										<div class="admin-item-list-top">
											<div class="admin-item-list-row">
                        <div class="admin-item-checkbox">
													<div class="admin-checkbox-input">
														<input name="cssCheckbox" id="allCheckInput" type="checkbox" class="css-checkbox" @change="toggleAllEmailLogsSelection" v-model="selectAll" />
														<label for="allCheckInput"></label>
													</div>
												</div>
												<div class="email-logs-date-time" @click="toggleSort('Created_at')" style="cursor: pointer;">
                          {{ constants.DATE_LABEL }}
                          <button v-if="sortBy === 'Created_at' || sortBy === '-Created_at'" class="sorting-btn" :class="{ 'sorted': sortBy === '-Created_at' }"></button>
												</div>
												<div class="email-logs-from">
                          {{ constants.FROM_LABEL }}
												</div>
												<div class="email-logs-to" @click="toggleSort('email')" style="cursor: pointer;">
                          {{ constants.TO_LABEL }}
                          <button v-if="sortBy === 'email' || sortBy === '-email'" class="sorting-btn" :class="{ 'sorted': sortBy === '-email' }"></button>
												</div>
												<div class="email-logs-subject" @click="toggleSort('subject')" style="cursor: pointer;">
                          {{ constants.SUBJECT_LABEL }}
                          <button v-if="sortBy === 'subject' || sortBy === '-subject'" class="sorting-btn" :class="{ 'sorted': sortBy === '-subject' }"></button>
												</div>
												<div class="email-logs-action">
                          {{ constants.ACTION_LABEL }}
												</div>
											</div>
										</div>
										<div class="admin-item-list-btm">
											<div v-for="(emailLog, index) in emailLogs" :key="emailLog.id" :class="['admin-item-box', { 'show-edit-item': emailLog.isOpen }]">     
												<div class="admin-item-box-top">
													<div class="admin-item-list-row">
                            <div class="admin-item-checkbox">
															<div class="admin-checkbox-input">
																<input name="cssCheckbox" :id="'allCheckInput' + emailLog.id" type="checkbox" class="css-checkbox" @change="toggleSingleEmailLogSelection(emailLog.id)" :checked="selectedEmailLogs.includes(emailLog.id)" />
																<label :for="'allCheckInput' + emailLog.id"></label>
															</div>
														</div>   
														<div class="email-logs-date-time">{{ formatDate(emailLog.Created_at) }}</div>
														<div class="email-logs-from">hr@lmdconsulting.com</div>
														<div class="email-logs-to">{{ emailLog.email }}</div>
														<div class="email-logs-subject text-limit">{{ emailLog.subject }}</div>
														<div class="email-logs-action">
															<ul class="admin-action-link">
																<li>    
																	<button class="editBtn" @click="viewEmailLog(emailLog, index)" :disabled="emailLog.isOpen">
                          {{ constants.VIEW_BUTTON }}
																	</button>
																</li>
																<li>
																	<button data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('single', emailLog.id)" :disabled="emailLog.isOpen">
                          {{ constants.DELETE_BUTTON }}
																	</button>
																</li>
															</ul>
														</div>
													</div>
												</div>
												<div class="admin-item-box-btm">
													<div class="email-log-content">
														<button id="closeBtn" class="emaillog-hide" @click="closeEmailLog(index)"></button>
														<ul>
															<li>
																<div class="email-log-item">
																	<label>
                          {{ constants.FROM_LABEL }}
																	</label>
																	<span>hr@lmdconsulting.com</span>
																</div>
																<div class="email-log-date">{{ formatDate(emailLog.Created_at) }}</div>
															</li>
															<li>
																<div class="email-log-item">
																	<label>
                          {{ constants.SUBJECT_LABEL }}
																	</label>
																	<span>{{ emailLog.subject }}</span>
																</div>
															</li>
															<li>
																<div class="email-log-item">
																	<label>
                          {{ constants.TO_LABEL }}
																	</label>
																	<span>{{ emailLog.email }}</span>
																</div>
															</li>
															<li>
																<div class="email-log-full-message">
																	<div v-html="emailLog.emailContent"></div>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<div v-if="emailLogs.length === 0" class="no-data-message">
											<p>No email logs found</p>
										</div>
									</div>
								</div>
								<div class="admin-pagination-section">
									<div class="custom-row">
										<div class="item-show-selectbox">
											<select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
												<option value="10">10</option>
												<option value="20">20</option>
												<option value="50">50</option>
												<option value="100">100</option>
											</select>
											<span>
                                  {{ constants.ENTRIES_PER_PAGE_LABEL }}
											</span>
										</div>
										<div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
											<ul>
												<li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
													<a href="#" class="pagination-previous"></a>
												</li>
												<li v-for="page in visiblePages" :key="page" @click="changePage(page)" v-if="totalPages != 1">
													<a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
												</li>
												<li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
													<a href="#" class="pagination-next"></a>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
			</section>
      </div>
    </section>
    <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog"
      aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-icon">
            <i>
              <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
            </i>
          </div>
          <div class="confirmation-popup-mid">
            <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
          </div>
          <div class="confirmation-popup-btm">
            <button class="admin-btn-outline-secondary" data-bs-dismiss="modal">
              {{ constants.NO_BUTTON }}
            </button>
            <button class="admin-btn-outline-primary" data-bs-dismiss="modal" @click="confirmDelete">
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { API_BASE_URL } from '@/config/api.config';
import Swal from 'sweetalert2';
import moment from 'moment';
import { getPaginationLimit, setPaginationLimit } from "@/utils/paginationUtils";

interface EmailLog {
  id: number;
  Created_at: string;
  email: string;
  subject: string;
  emailContent: string;
  isOpen: boolean;
}

export default defineComponent({
  components: {
    adminHeader,
    adminNavigation,
  },
  name: 'EmailLogs',
  data() {
    return {
      constants,
      emailLogs: [] as EmailLog[],
      emailLogToDelete: null as number | null,
      deleteMode: "all" as "all" | "single",
      currentPage: 1,
      limit: 10,
      totalPages: 0,
      totalCount: 0,
      selectedEmailLogs: [] as number[],
      searchedText: "",
      searchTempVar: "",
      selectAll: false,
      sortBy: "" as string,
    };
  },
  created() {
    this.limit = getPaginationLimit("emailLogs", 10);
    this.fetchCounts();
    this.fetchEmailLogs();
  },
  computed: {
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  methods: {
    async fetchEmailLogs() {
      try {
        const skip = (this.currentPage - 1) * this.limit;
        const params = new URLSearchParams();
        if (this.searchedText) {
          if (!this.searchTempVar) {
            this.limit = 10;
            this.currentPage = 1;
          }
          this.searchTempVar = this.searchedText;
        }
        if (!this.searchedText) {
          if (this.searchTempVar) {
            this.currentPage = 1;
            this.limit = 10;
            this.searchTempVar = "";
          }
          params.append("limit", this.limit.toString());
          params.append("skip", skip.toString());
        }
        if (this.searchedText) {
          params.append("limit", this.limit.toString());
          params.append("skip", skip.toString());
          params.append("searchedText", this.searchedText);
        }
        params.append("sort_by", this.sortBy);
        
        const response = await axios.get(`${API_BASE_URL}/candidates-email-threads/?${params.toString()}`);
        
        this.emailLogs = (response.data || []).map((log: any) => ({
          ...log,
          isOpen: Boolean(log.isOpen),
        }));
      } catch (error) {
        console.error('Error fetching email logs:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch email logs',
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async fetchCounts() {
      try {
        const params = new URLSearchParams();

        if (this.searchedText) {
          params.append("searchedText", this.searchedText);
        }

        const response = await axios.get(`${API_BASE_URL}/candidates-email-threads/count/`, {
          params,
        });

        this.totalCount = response.data.count;
        this.totalPages = Math.ceil(this.totalCount / this.limit);

      } catch(error) {
        console.error('Error fetching email logs counts:', error);
      }
    },
    viewEmailLog(emailLog: EmailLog, index: number) {
      this.emailLogs.forEach((log: EmailLog, i: number) => {
        if (i !== index) {
          log.isOpen = false;
        }
      });
      this.emailLogs[index].isOpen = !this.emailLogs[index].isOpen;
    },
    closeEmailLog(index: number) {
      this.emailLogs[index].isOpen = false;
    },
    setDeleteMode(mode: "all" | "single", emailLogId?: number) {
      this.deleteMode = mode;
      if (emailLogId !== undefined) {
        this.emailLogToDelete = emailLogId;
      }
    },
    formatDate(date: any) {
      const nyDate = moment.utc(date).tz("America/New_York");
      return nyDate.format("MMM DD, YYYY h:mm A");
    },
    async changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        await this.fetchEmailLogs();
        this.selectAll = this.emailLogs.length > 0 && this.emailLogs.every((emailLog) => this.selectedEmailLogs.includes(emailLog.id));
      }
    },
    async handleLimitChange() {
      setPaginationLimit("emailLogs", this.limit);
      this.currentPage = 1;
      await this.fetchEmailLogs();
      this.selectAll = this.emailLogs.length > 0 && this.emailLogs.every((emailLog) => this.selectedEmailLogs.includes(emailLog.id));
    },
    toggleSingleEmailLogSelection(emailLogId: number) {
      if (this.selectedEmailLogs.includes(emailLogId)) {
        this.selectedEmailLogs = this.selectedEmailLogs.filter(id => id !== emailLogId);
      } else {
        this.selectedEmailLogs.push(emailLogId);
      }
    },
    toggleAllEmailLogsSelection() {
      if (this.selectAll) {
        this.selectedEmailLogs = [
          ...new Set([
            ...this.selectedEmailLogs,
            ...this.emailLogs.map((emailLog: EmailLog) => emailLog.id),
          ]),
        ];
      } else {
        this.selectedEmailLogs = this.selectedEmailLogs.filter(
          (id) => !this.emailLogs.map((emailLog: EmailLog) => emailLog.id).includes(id)
        );
        this.selectAll = false;
      }
    },
    confirmDelete() {
      if (this.deleteMode === "all") {
        this.deleteSelectedEmailLogs();
      } else if (this.deleteMode === "single") {
        this.deleteEmailLog();
      }
    },
    async deleteSelectedEmailLogs() {
      try {
        await axios.delete(`${API_BASE_URL}/candidates-email-threads/bulk_delete/`, {
          data: { ids: this.selectedEmailLogs },
        });
        this.emailLogs = this.emailLogs.filter(emailLog => !this.selectedEmailLogs.includes(emailLog.id));
        this.selectedEmailLogs = [];
        this.selectAll = false;
        await this.fetchEmailLogs();
        
        if (this.emailLogs.length === 0) {
          this.currentPage--;
          if (this.currentPage < 1) {
            this.currentPage = 1;
          }
          this.fetchEmailLogs();
        }
        this.fetchCounts();
        Swal.fire({
          icon: 'success',
          title: 'Email Log Deleted Successfully!',
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error) {
        console.error('Error deleting email log:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to delete email log',
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async deleteEmailLog() {
      try {
        await axios.delete(`${API_BASE_URL}/candidates-email-threads/${this.emailLogToDelete}/`);
        
        await this.fetchEmailLogs();
        
        if (this.emailLogs.length === 0) {
          this.currentPage--;
          if (this.currentPage < 1) {
            this.currentPage = 1;
          }
          this.fetchEmailLogs();
        }
        this.fetchCounts();
        Swal.fire({
          icon: 'success',
          title: 'Email Log Deleted Successfully!',
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error) {
        console.error('Error deleting email log:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to delete email log',
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    toggleSort(field: string) {
        if (this.sortBy === field) {
            this.sortBy = `-${field}`; 
        } else if (this.sortBy === `-${field}`) {
            this.sortBy = ''; 
        } else {
            this.sortBy = field; 
        }
        this.fetchEmailLogs();
    },
  }
})
</script>